export default "__VITE_ASSET__DOa683av__"